var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDarkSendIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.941,
    height: 33.941,
    viewBox: "0 0 33.941 33.941",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "send_icon_",
    "data-name": "send icon ",
    transform: "translate(23 -4.971) rotate(45)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18489",
    "data-name": "Rectangle 18489",
    width: 24,
    height: 24,
    transform: "translate(-0.749 7.778)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_15479",
    "data-name": "Group 15479",
    transform: "translate(-1.213 8.485)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1396",
    "data-name": "Line 1396",
    x1: 11,
    y2: 11,
    transform: "translate(11 2)",
    fill: "none",
    stroke: "#0086ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45625",
    "data-name": "Path 45625",
    d: "M22,2,15,22l-4-9L2,9Z",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#0086ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkSendIcon);
export default __webpack_public_path__ + "static/media/darkSendIcon.6cedbc20707914ef3a55d168afc90e99.svg";
export { ForwardRef as ReactComponent };